import styled from 'styled-components';
import { Link } from 'gatsby';
import { primaryBoxButtonStyles } from '../../utils/styles';

const LinkBox = styled(Link)`
  ${primaryBoxButtonStyles};
`;

export default LinkBox;
